import React from "react";

// Rendered in the detail pane at a split-view's index route (nothing
// selected yet) - generic across every module using MasterDetailLayout so
// each one doesn't need its own copy of this markup.
const MasterDetailEmptyState = ({ icon: Icon, text }) => (
  <div className="master-detail-empty-state">
    {Icon && <Icon size={40} className="text-muted mb-2" />}
    <div className="text-muted">{text}</div>
  </div>
);

export default MasterDetailEmptyState;
